import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { DialogBase, DialogCloseReason } from '../../dialogs/base-dialog';
import { InputSettings, Settings } from './interface';

interface ICdDateTimePickerOverlayDialogInitData {
  hostElementPosition: ClientRect;
  calendarSettings: InputSettings;
  initialValue: Date;
}

@Component({
  selector: 'cd-date-time-picker-overlay-dialog',
  templateUrl: 'cd-date-time-picker-overlay-dialog.html',
  styles: [`
      /deep/ .cd-date-time-picker-overlay-dialog-backdrop {
          opacity: 0.2;
      }

      .date-time-picker-overlay-container {
          position: absolute;
      }

      /deep/ .date-time-picker-overlay-container--centered .wc-date-container {
          visibility: hidden;
      }
  `]
})
export class CdDateTimePickerOverlayDialogComponent extends DialogBase implements OnDestroy {
  windowResizeHandler: any;

  dateTimePickerStyle: { top: any; left: any } = null;
  dateTime: Date;

  calendarSettings: Settings;

  visibility: string = 'hidden';

  showAsCentered = false;

  constructor(private dialogElement: ElementRef) {
    super();

  }

  onDateTimeSelected($event: any) {
    this.close({ reason: DialogCloseReason.OK, data: { dateSelected: $event } });
  }

  onWindowResize(event: Event) {
    this.close({ reason: DialogCloseReason.CANCEL });
  }

  initDialog() {
    this.windowResizeHandler = this.onWindowResize.bind(this);
    window.addEventListener('resize', this.windowResizeHandler);

    let dialogInitData: ICdDateTimePickerOverlayDialogInitData = this.extraData;

    this.calendarSettings = this.extraData.calendarSettings;
    //override some settings cause we are opening it from a dialog and there are some things that needs to be changed for this implementation:
    this.calendarSettings.defaultOpen = true;
    this.calendarSettings.closeOnSelect = false;

    this.dateTimePickerStyle = {
      'top': dialogInitData.hostElementPosition.top.toString() + 'px',
      'left': dialogInitData.hostElementPosition.left.toString() + 'px'
    };

    if (dialogInitData.initialValue) {
      this.dateTime = new Date(dialogInitData.initialValue);
    } else {
      //default to start from today.
      this.dateTime = new Date();
      //remove the seconds and milliseconds they might interfere with comparisons of times
      this.dateTime.setSeconds(0);
      this.dateTime.setMilliseconds(0);
    }

    setTimeout(() => {
      this.onAfterViewIsShown();
    });
  }

  //check if the calendar drop-down is out of screen and if so we shell show it on the middle.
  onAfterViewIsShown() {
    let dialogBoundingRect = this.dialogElement.nativeElement.getBoundingClientRect();
    let calendarPopoverElement = this.dialogElement.nativeElement.querySelector('.wc-date-popover');
    let calendarDateContainerElement = this.dialogElement.nativeElement.querySelector('.wc-date-container');

    let calendarPopoverBoundingRect = calendarPopoverElement.getBoundingClientRect();
    let calendarDateContainerBoundingRect = calendarDateContainerElement.getBoundingClientRect();

    if ((calendarPopoverBoundingRect.bottom > dialogBoundingRect.bottom) || (calendarPopoverBoundingRect.right > dialogBoundingRect.right)) {
      //here we make it show in the middle instead of the given coordinates
      this.showAsCentered = true;
      let newLeftPosition = Math.floor(dialogBoundingRect.width / 2) - Math.floor(calendarPopoverBoundingRect.width / 2);
      let newTopPosition = Math.floor(dialogBoundingRect.height / 2)
        - Math.floor(calendarPopoverBoundingRect.height / 2)
        - calendarDateContainerBoundingRect.height;

      this.dateTimePickerStyle = {
        'top': newTopPosition.toString() + 'px',
        'left': newLeftPosition.toString() + 'px'
      };
    }


    this.visibility = 'visible';
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.windowResizeHandler);
  }
}
